import {Avatar, ListItem, ListItemAvatar, ListItemText, Paper} from "@mui/material";
import {CoineusUSDFormat, CoineusCryptoFormat} from "../utils/currency_format";
import clsx from "clsx";
import {makeStyles} from "@mui/styles";

import TokenInfoDialog from "./TokenInfoDialog";
import {useState} from "react";
import {useSelector} from "react-redux";
import millify from "millify";

const useStyles = makeStyles((theme) => ({
    networkChip: {
        borderRadius: "50%",
        marginLeft: 30,
        position: 'absolute',
        top: 42,
        height: 16,
        width: 16,
        display: 'inline-block',
        backgroundSize: 'cover',
        '&.fuse': {
            backgroundImage: `url('https://coineus.app/assets/tokens/fuse/logo.png')`,
        },
        '&.avax': {
            backgroundImage: `url('https://coineus.app/assets/tokens/avax/logo.png')`,
        },
        '&.bnb': {
            backgroundImage: `url('https://coineus.app/assets/tokens/bnb/logo.png')`,
        },
        '&.eth': {
            backgroundImage: `url('https://coineus.app/assets/tokens/eth/logo.png')`,
        }
    }
}));

export default function TokenListItem(props) {

    const classes = useStyles();

    const {wallet, settings} = useSelector(state => state.coineus);

    const {
        contract_address,
        pair,
        name,
        network,
        price,
        rewards,
        rewardsClaim,
        native,
        wrap,
        secondaryAction,
        rewardsSymbol,
        rewardsRealised,
    } = props;

    const [open, setOpen] = useState(false);

    if (wallet.balances[network] === undefined) {
        return <></>;
    }

    const displayPrice = (price) => {
        return CoineusUSDFormat(price);
    }

    if (wallet.balances[network][contract_address] < .01 && !settings.showZeroBalance) {
        if(wallet.staked[network][contract_address] === undefined || wallet.staked[network][contract_address] < .0000001) {
            return <></>;
        }
    }

    return <Paper style={{marginTop: 10, marginBottom: 5}}>
        <ListItem secondaryAction={secondaryAction}>
            <ListItemAvatar onClick={() => setOpen(true)}>
                <Avatar
                    src={`https://coineus.app/assets/tokens/${network}/${contract_address === 'native' ? '' : contract_address + '/'}logo.png`}/>
                {network && !native && <span className={clsx(classes.networkChip, network)}/>}
            </ListItemAvatar>

            <ListItemText
                primary={name}
                secondary={settings.visibility ? displayPrice(price?.inUSD) : '*****'}
                style={{minWidth: 80, maxWidth: 80, flex: 1}}
            />

            <ListItemText
                primary={settings.visibility ? wallet.balances[network][contract_address] > 1000000 ? millify(wallet.balances[network][contract_address]) : CoineusCryptoFormat(wallet.balances[network][contract_address]) : '*****'}
                secondary={settings.visibility ? CoineusUSDFormat(price?.inUSD * wallet.balances[network][contract_address]) : '*****'}
                primaryTypographyProps={{textAlign: 'right'}}
                secondaryTypographyProps={{textAlign: 'right'}}
            />
        </ListItem>

        {
            wallet.staked[network][contract_address] > 0 && <>
                <ListItem style={{color: '#fbca00', paddingTop: 0}}>
                    <ListItemText
                        primary='Staked'
                        secondary="Value"
                    />
                    <ListItemText
                        primary={settings.visibility ? `${CoineusCryptoFormat(wallet.staked[network]?.[contract_address])} ${name}` : '*****'}
                        secondary={settings.visibility ? CoineusUSDFormat(wallet.staked[network]?.[contract_address] * price?.inUSD) : '*****'}
                        primaryTypographyProps={{textAlign: 'right'}}
                        secondaryTypographyProps={{textAlign: 'right'}}
                    />
                </ListItem>
            </>
        }

        {
            rewards !== undefined && <>
                <ListItem secondaryAction={rewardsClaim} style={{color: '#fbca00', paddingTop: 0}}>
                    <ListItemText
                        primary={settings.visibility ? `${CoineusCryptoFormat(rewardsRealised)} ${rewardsSymbol}` : '*****'}
                        secondary="Rewards All-time"
                    />
                    <ListItemText
                        primary={`${CoineusCryptoFormat(rewards)} ${rewardsSymbol}`}
                        secondary="Pending"
                        primaryTypographyProps={{textAlign: 'right', paddingRight:1}}
                        secondaryTypographyProps={{textAlign: 'right', paddingRight:1}}
                    />
                </ListItem>
            </>
        }


        {/*TODO work on token details*/}
        <TokenInfoDialog
            contract_address={contract_address}
            wrap={wrap}
            network={network}
            open={open}
            close={() => setOpen(false)}
            pair={pair}
        />
    </Paper>
}